import { Dictionary } from "../dictionary";
const toDict = (attr) => {
    const dictionary = new Dictionary();
    attr.forEach(a => dictionary.put(a.id, a.levelCosts));
    return dictionary;
};
export { toDict };
